var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',_vm._b({attrs:{"inline":true,"lang":_vm.lang},on:{"change":function($event){return _vm.$emit('on:calendar-change', _vm.model)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'date-picker',{ ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }